/**
 * @file app/tauri/bootTauri.web.js  (web / desktop)
 *
 * Web/desktop boot. Importing this module installs the Electron-compatibility
 * globals (`window.ipcRenderer`, `window.appStorage`, `window.startMQTTService`,
 * …) synchronously — BEFORE React mounts — so the react-native-web renderer runs
 * unchanged under Tauri. The async tail (store cache warming, version, updater
 * listener) completes shortly after; the synchronous globals are ready first.
 *
 * Safe in a plain browser too (not just Tauri): `initTauriCompat()` detects the
 * absence of `window.__TAURI__` and installs harmless shims, so the same web
 * bundle still deploys to the browser / Cloudflare Pages.
 *
 * webpack resolves `./bootTauri` to THIS file (`.web.js` first); Metro resolves
 * it to the native no-op sibling, keeping `@tauri-apps/*` out of the app bundle.
 */

import { initTauriCompat } from "./tauriCompat";
import { initTauriSentry } from "./sentryTauri";
import { getMiniApp } from "../config/appVariant";
import { installMiniAppChrome } from "./miniAppNative";

// Install the Electron surface immediately (synchronous part runs before the
// first await inside initTauriCompat), then let the async tail settle.
initTauriCompat();
// Renderer-side crash reporting (no-op unless actually under Tauri).
initTauriSentry();

// Happy Time Tracker / Happy Team Chat: native-app window chrome (macOS drag
// strip + inset, no browser zoom / context menu). No-op for the full Happy App.
const miniApp = getMiniApp();
if (miniApp && typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => installMiniAppChrome(miniApp), { once: true });
  } else {
    installMiniAppChrome(miniApp);
  }
}

export default function bootTauri() {
  /* side effects already ran at import time */
}
